import { Icon } from '@skin-seoul/design-system';
import type { ComponentProps } from 'react';
import React from 'react';

type CartCloseIcon = ComponentProps<typeof Icon>;

const CartCloseIcon = ({ ...props }: CartCloseIcon) => {
  return (
    <Icon width="24px" height="24px" {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="45" fill="transparent" stroke="black" strokeWidth="4" />
        <path d="M35 35 L65 65 M65 35 L35 65" stroke="black" strokeWidth="8" strokeLinecap="round" />
      </svg>
    </Icon>
  );
};

export default CartCloseIcon;
